import { ChecksPayableInfo } from "@ollie-sports/models";
import { getUniversalHelpers } from "../../helpers";

export async function team__client__setChecksPayableInfo(p: { teamId: string; checksPayableInfo?: ChecksPayableInfo }) {
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  await h.Team.update({ id: p.teamId, doc: { checksPayableInfo: p.checksPayableInfo ?? h._MagicDeleteValue } });
}

// i18n certified - complete
